/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import Pagination from 'components/common/pagination';
import Table from 'components/Form/Table';
import EmptyState from 'components/EmptyState';
import Fetching from 'components/Fetching';
import moment from 'moment';
import Transactiondetails from 'container/Transactions/transactiondetails';
import styles from '../terminal.module.scss';
import { formatCurrency, statusTextColorMapping } from '../../../libs';
import Badge from '../../../components/Badge';
import angleRight from '../../../assets/images/angle-right.png';

const TerminalDetailsTable = (props) => {
  const { inProgress, page, meta, handlePageClick, txt } = props;
  const [drawerActive, setDrawerActive] = useState(false);
  const [currentDetail, setCurrentDetail] = useState({});

  return (
    <>
      {inProgress ? (
        <div className={styles.terminalListEmpty}>
          <Fetching />
        </div>
      ) : txt && txt.length === 0 ? (
        <div className={styles.terminalListEmpty}>
          <EmptyState text="Your transactions will show up here as you start using your terminal" />
        </div>
      ) : (
        <>
          <Transactiondetails
            drawerActive={drawerActive}
            setDrawerActive={setDrawerActive}
            txtRow={currentDetail}
          />
          <div
            className={styles.terminalTransactionTable}
            data-testid="terminal-log-table"
          >
            <div className={styles.terminalListContentBody} />
            <Table>
              <Table.Thead>
                <Table.Tr>
                  <Table.Th>ID</Table.Th>
                  <Table.Th>AMOUNT</Table.Th>
                  <Table.Th>PAYMENT DATE</Table.Th>
                  <Table.Th>STATUS</Table.Th>
                  <Table.Th />
                </Table.Tr>
              </Table.Thead>
              <Table.TBody>
                {txt.map((item, index) => (
                  <Table.Tr key={index}>
                    <Table.Td>{`${item.id}`}</Table.Td>
                    <Table.Td>{formatCurrency(item.amount)}</Table.Td>
                    <Table.Td>
                      {item.createdAt &&
                        moment(item.createdAt).format('DD MMMM YYYY hh:mm A')}
                    </Table.Td>
                    <Table.Td>
                      <Badge color={statusTextColorMapping[item.status]?.color}>
                        {statusTextColorMapping[item.status]?.text}
                      </Badge>
                    </Table.Td>
                    <Table.Td>
                      <button
                        type="button"
                        onClick={() => {
                          setCurrentDetail(item);
                          setDrawerActive(true);
                        }}
                      >
                        <img
                          src={angleRight}
                          alt="angleRight"
                          data-testid="click-details-list"
                        />
                      </button>
                    </Table.Td>
                  </Table.Tr>
                ))}
              </Table.TBody>
            </Table>
          </div>
          <div
            className={styles.terminalAltPagination}
            data-testid="pagination"
          >
            <p>
              Showing{' '}
              {meta.page === 0 ? txt.length : txt.length * (meta.page + 1)}{' '}
              items out of {Math.ceil(meta.total / meta.limit)}
              {Math.ceil(meta.total / meta.limit) > 1 ? ' pages' : ' page'}{' '}
              found
            </p>
            <div>
              <Pagination
                currentPage={page}
                handlePageClick={handlePageClick}
                totalItems={Math.ceil(meta.total / meta.limit)}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default TerminalDetailsTable;
